var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"fulls"},[_c('tbody',[_c('div',{attrs:{"id":"print-preview-topic"}}),_c('div',{attrs:{"id":"print-preview-content"}})]),_c('tfoot',{staticClass:"footer"},[_c('div',{attrs:{"id":"print-preview-footer"}})])])
}]

export { render, staticRenderFns }